import './style.scss';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { URL } from '../BackendApi';

// Accessible accordion item, shared by the page-level FAQ and the inline CMS FAQ.
// Question is a real <button> inside an <h3>; the answer stays in the DOM and is
// toggled with the `hidden` attribute so search engines and screen readers see it.
export const FAQItem = ({ id, question, answerHtml, expanded, onToggle, questionIsHtml = false }) => {
  const panelId = `${id}-panel`;
  const buttonId = `${id}-button`;
  return (
    <div className={'question' + (expanded ? ' expanded' : '')}>
      <h3 className="question__heading">
        <button
          type="button"
          id={buttonId}
          className="question__button"
          aria-expanded={expanded ? 'true' : 'false'}
          aria-controls={panelId}
          onClick={onToggle}
        >
          {questionIsHtml
            ? <span dangerouslySetInnerHTML={{ __html: question }} />
            : <span>{question}</span>}
          <span className="question__icon" aria-hidden="true"></span>
        </button>
      </h3>
      <div
        id={panelId}
        className="question__answer"
        role="region"
        aria-labelledby={buttonId}
        hidden={!expanded}
        dangerouslySetInnerHTML={{ __html: answerHtml || '' }}
      />
    </div>
  );
};

class FAQ extends Component {
  constructor(props) {
    super(props);
    this.state = {
      questions: [],
      loading: true,
      error: null,
      expandedQuestion: ''
    };
  }

  componentDidMount() {
    this.fetchQuestions();
  }

  componentDidUpdate(prevProps) {
    // Refetch if the URL changes
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.fetchQuestions();
    }
  }

  toggleExpandedQuestion(key) {
    if (this.state.expandedQuestion === key) {
      this.setState({ expandedQuestion: '' });
    } else {
      this.setState({ expandedQuestion: key });
    }
  }

  fetchQuestions() {
    this.setState({ loading: true });

    // Get the current URL path
    const url = this.props.location.pathname;

    fetch(`${URL}/questions/public?url=${encodeURIComponent(url)}`)
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        this.setState({
          questions: data,
          loading: false,
          error: null
        });
      })
      .catch(error => {
        console.error('Error fetching FAQ questions:', error);
        this.setState({
          questions: [],
          loading: false,
          error: error.message
        });
      });
  }

  render() {
    const { questions, loading, error, expandedQuestion } = this.state;

    if (loading) {
      return (
        <Container fluid className="p-b-50 p-t-50">
          <Row>
            <Col>
              <Container>
                <Row>
                  <Col sm={{ span: 8, offset: 2 }}>
                    <h2 className="faq__heading p-b-25">Meiltä usein kysyttyä</h2>
                    <p>Ladataan kysymyksiä...</p>
                  </Col>
                </Row>
              </Container>
            </Col>
          </Row>
        </Container>
      );
    }

    if (error) {
      console.error('Error displaying FAQ:', error);
      return null; // Don't show anything if there's an error
    }

    if (questions.length === 0) {
      return null; // Don't show the FAQ section if there are no questions
    }

    return (
      <Container fluid className="p-b-50 p-t-50">
        <Row>
          <Col>
            <Container>
              <Row>
                <Col sm={{ span: 8, offset: 2 }}>
                  <section className="faq" aria-labelledby="faq-heading">
                    <h2 id="faq-heading" className="faq__heading p-b-25">Meiltä usein kysyttyä</h2>

                    {questions.map((question, index) => (
                      <FAQItem
                        key={question.id || index}
                        id={`faq-${question.id || index}`}
                        question={question.title}
                        answerHtml={question.body}
                        expanded={expandedQuestion === index}
                        onToggle={() => this.toggleExpandedQuestion(index)}
                      />
                    ))}
                  </section>
                </Col>
              </Row>
            </Container>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default withRouter(FAQ);
